import vhCheck from "vh-check";

let root, window_width;
const setWindowSize = () => {
  if (!root) root = document.documentElement;
  
  if (window.innerWidth > 1100 || window_width != window.innerWidth) {
    window_width = window.innerWidth;
    root.style.setProperty("--vh", vhCheck().vh + "px");
    root.style.setProperty("--windowHeight", vhCheck().windowHeight + "px");
  }
};

export { setWindowSize };
